export type GetMedicalProfileUsageMetricStatusResponse = {
    used: number;
    allowed: number | 'unlimited';
};
